import { useTranslation } from 'react-i18next';

import { MetaTags } from '../../../../hub/shared/MetaTags';
import Layout from '../../../shared/layouts/Layout';
import PageLayout from '../../../shared/layouts/PageLayout';
import PaymentProvider from '../../../shared/PaymentProvider';
import PaymentJourneyMessage from '../../../shared/components/PaymentJourneyMessage';
import BookingButton from '../../../shared/components/BookingButton';

export default function OrderExpired() {
  const { t } = useTranslation();

  return (
    <PaymentProvider>
      <Layout disableUpperFooter>
        <MetaTags title={t('site.pricing.payment-expired')} />
        <PageLayout variant="full">
          <PaymentJourneyMessage
            title={t('site.pricing.payment-expired')}
            description={
              <>
                <p>{t('site.pricing.payment-expired.text-1')}</p>
                <p>{t('site.pricing.payment-expired.text-2')}</p>
              </>
            }
            button={<BookingButton size="small" />}
          />
        </PageLayout>
      </Layout>
    </PaymentProvider>
  );
}
